import { call, put, takeLatest, delay } from 'redux-saga/effects';

import {
	getEnabledPlans,
	getEnabledPlansSuccess,
	getEnabledPlansFailure,
	getPlans,
	getPlansSuccess,
	getPlansFailure,
	getPlanByName,
	getPlanByNameSuccess,
	getPlanByNameFailure,
} from '.';

import planService from '../../../services/PlanService';

function* rootSaga() {
	yield takeLatest(getEnabledPlans, getEnabledPlansSaga);
	yield takeLatest(getPlans, getPlansSaga);
	yield takeLatest(getPlanByName, getPlanByNameSaga);
}

function* getEnabledPlansSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(planService.getAllEnabled, payload);
		yield put(getEnabledPlansSuccess(response));
	} catch (error) {
		yield put(getEnabledPlansFailure(error));
	}
}

function* getPlansSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(planService.getAll, payload);
		yield put(getPlansSuccess(response));
	} catch (error) {
		yield put(getPlansFailure(error));
	}
}

function* getPlanByNameSaga({ payload }) {
	try {
		yield delay(300);
		const plan = yield call(planService.getByName, payload);
		yield put(getPlanByNameSuccess(plan));
	} catch (error) {
		yield put(getPlanByNameFailure(error));
	}
}

export default rootSaga;
